import { render, staticRenderFns } from "./MiniDivider.vue?vue&type=template&id=45a0f39a&scoped=true"
import script from "./MiniDivider.vue?vue&type=script&lang=js"
export * from "./MiniDivider.vue?vue&type=script&lang=js"
import style0 from "./MiniDivider.vue?vue&type=style&index=0&id=45a0f39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a0f39a",
  null
  
)

export default component.exports